import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import React from 'react';
import dynamic from "next/dynamic";
import {useRouter} from 'next/router';
import Config from '../../config';
import { getStaticPath } from '../../utils';

const CustomerConsent = dynamic(()=> import('../../src/common/components/customer-consent/index'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

export async function getServerSideProps() {
  return {
    props: {
      pageName: 'customer-consent'
    }
  }
}

export default function Home(props) {
  const router = useRouter()
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath("/static/images/why-onsitego.svg")
  return (
    <>
      <Head>
        <title>Customer Consent</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content="Discover Onsitego’s terms & Condition for Lending Services, outlining our commitment to customer consent, data handling, and privacy standards."></meta>
        <meta property="og:title" content="Customer Consent"/>
        <meta property="og:description" content="Discover Onsitego’s terms & Condition for Lending Services, outlining our commitment to customer consent, data handling, and privacy standards."/>
        <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
        <meta property="og:image" content={OG_IMAGE}/>
        <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
      </Head>
      <PlainBanner title="Customer Consent" />
      <CustomerConsent />
    </>
  )
}